import lozad from 'lozad'

let lozadElements = document.querySelectorAll("[data-lazy='true']")
if (lozadElements.length > 0) {
    lozad("[data-lazy='true']", {
        load: function (el) {
            el.src = el.dataset.src;
            el.onload = function () {
                el.classList.add('lozad-loaded');
            }
        }
    }).observe()
}